import { mapGetters } from 'vuex'
import { openReviewer } from '@/api/open'
import { settingOption } from '@/api/setting'

export default {
  components: {},
  data() {
    return {
      detail: {},
      reviews: {
        reason: '',
        reasonCode: '',
        reviewerList: []
      },
      code: '',
      reviewRefuseList: []
    }
  },
  async mounted() {
    this.getData()
  },
  methods: {
    async submit() {
      const info = await openReviewer.reviewsCode(this.code)
      if (info.status === 'DECLINED') {
        this.$router.push(`/email-url/invalid-page?code=${this.code}`)
        return
      }
      if (this.reviews.reason.length > 1024) {
        this.$message.error({
          title: 'Error',
          content: 'The reason exceeds the maximum length (1024 words)!'
        })
        return
      }
      let data = Object.assign(
        {
          id: this.detail.id,
          version: this.detail.version,
          status: 'DECLINED'
        },
        this.reviews
      )
      await openReviewer.confirmCode(this.code, data)
      this.$message.success({
        title: 'Success',
        content: 'Decline Successfully'
      })
      // this.$router.push(`/email-url/invalid-page?code=${this.code}`)
    },
    // 获取数据
    async getData() {
      this.code = this.$route.query.reviewskey
      const data = await openReviewer.reviewsCode(this.code)
      const reviewRefuseList = await settingOption.get({
        type: 'REVIEWER_REFUSE_REASON'
      })
      this.detail = data
      this.reviewRefuseList = reviewRefuseList
    },
    addReviewer() {
      this.reviews.reviewerList.push({
        firstName: '',
        lastName: '',
        email: ''
      })
    },
    delReviewer(index) {
      this.$confirm({
        title: 'Are you sure you want to delete this data?',
        content:
          'Please be aware of once this data is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        this.reviews.reviewerList.splice(index, 1)
        this.$message.success({
          title: 'Success',
          content: 'This Data has been deleted!'
        })
      })
    }
  }
}
